<template>
  <b-container fluid>
    <b-row>
      <b-col cols="12">
        <b-row class="d-flex align-items-center">
          <b-col cols="6">
            <h1 class="font-weight-bold" style="font-size: 24px">
              Marketing Dashboard
            </h1>
          </b-col>
          <b-col cols="2" class="d-flex">
            <v-select
              :value="option"
              :options="options"
              :reduce="(val) => val.value"
              :clearable="false"
              @input="(val) => (option = val.value)"
              class="w-100"
            />
          </b-col>
          <b-col cols="4" class="text-right">
            <b-button size="md" variant="primary">
              <feather-icon icon="PlusIcon" />
              <span class="text-lg text-nowrap" style="margin-left: 4px"
                >Create promotions</span
              >
            </b-button>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col cols="6" md="3">
            <b-card>
              <b-card-body>
                <b-row>
                  <b-col md="12">
                    <h4 class="font-weight-bold text-nowrap text-center">
                      Active Campaigns
                    </h4>
                  </b-col>
                  <b-col md="12">
                    <div class="d-flex align-items-end justify-content-center">
                      <h1 class="text-primary mb-0" style="line-height: 1">
                        24
                      </h1>
                      <div class="d-flex align-items-center ml-1">
                        <feather-icon
                          class="text-success"
                          icon="ChevronUpIcon"
                          size="16"
                        />
                        <span
                          class="font-weight-bold text-success"
                          style="font-size: 16px"
                          >12%</span
                        >
                      </div>
                    </div>
                    <span class="text-muted d-inline-block w-100 text-center"
                      >vs previous month</span
                    >
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col cols="6" md="3">
            <b-card>
              <b-card-body>
                <b-row>
                  <b-col md="12">
                    <h4 class="font-weight-bold text-nowrap text-center">
                      Customer Reach
                    </h4>
                  </b-col>
                  <b-col md="12">
                    <div class="d-flex align-items-end justify-content-center">
                      <h1 class="text-primary mb-0" style="line-height: 1">
                        245.8k
                      </h1>
                      <div class="d-flex align-items-center ml-1">
                        <feather-icon
                          class="text-danger"
                          icon="ChevronDownIcon"
                          size="16"
                        />
                        <span
                          class="font-weight-bold text-danger"
                          style="font-size: 16px"
                          >8%</span
                        >
                      </div>
                    </div>
                    <span class="text-muted d-inline-block w-100 text-center"
                      >This month</span
                    >
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col cols="6" md="3">
            <b-card>
              <b-card-body>
                <b-row>
                  <b-col md="12">
                    <h4 class="font-weight-bold text-nowrap text-center">
                      Engagement Rate
                    </h4>
                  </b-col>
                  <b-col md="12">
                    <div class="d-flex align-items-end justify-content-center">
                      <h1 class="text-primary mb-0" style="line-height: 1">
                        18.2%
                      </h1>
                      <div class="d-flex align-items-center ml-1">
                        <feather-icon
                          class="text-danger"
                          icon="ChevronDownIcon"
                          size="16"
                        />
                        <span
                          class="font-weight-bold text-danger"
                          style="font-size: 16px"
                          >2.1%</span
                        >
                      </div>
                    </div>
                    <span class="text-muted d-inline-block w-100 text-center"
                      >vs previous month</span
                    >
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col cols="6" md="3">
            <b-card>
              <b-card-body>
                <b-row>
                  <b-col md="12">
                    <h4 class="font-weight-bold text-nowrap text-center">
                      Conversion Rate
                    </h4>
                  </b-col>
                  <b-col md="12">
                    <div class="d-flex align-items-end justify-content-center">
                      <h1 class="text-primary mb-0" style="line-height: 1">
                        5.7%
                      </h1>
                      <div class="d-flex align-items-center ml-1">
                        <feather-icon
                          class="text-success"
                          icon="ChevronUpIcon"
                          size="16"
                        />
                        <span
                          class="font-weight-bold text-success"
                          style="font-size: 16px"
                          >0.8%</span
                        >
                      </div>
                    </div>
                    <span class="text-muted d-inline-block w-100 text-center"
                      >vs previous month</span
                    >
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-card>
              <b-row>
                <b-col cols="6" md="3">
                  <b-card border-variant="secondary" class="h-100">
                    <b-card-body>
                      <h5
                        class="text-body font-weight-bold text-nowrap text-center"
                      >
                        Campaign Engagement Trends
                      </h5>
                      <p
                        class="text-center mt-2 text-muted mb-0"
                        style="font-size:'16px"
                      >
                        Line Chart: Campaign Engagement Trends
                      </p>
                    </b-card-body>
                  </b-card>
                </b-col>
                <b-col cols="6" md="3">
                  <b-card border-variant="secondary" class="h-100">
                    <b-card-body>
                      <h5
                        class="text-body font-weight-bold text-nowrap text-center"
                      >
                        Channel Performance Comparison
                      </h5>
                      <p
                        class="text-center mt-2 text-muted mb-0"
                        style="font-size:'16px"
                      >
                        Bar Chart: Channel Performance (Banners, SMS, Push,
                        In-App)
                      </p>
                    </b-card-body>
                  </b-card>
                </b-col>
                <b-col cols="6" md="3">
                  <b-card border-variant="secondary" class="h-100">
                    <b-card-body>
                      <h5
                        class="text-body font-weight-bold text-nowrap text-center"
                      >
                        Customer Segment Response Rates
                      </h5>
                      <p
                        class="text-center mt-2 text-muted mb-0"
                        style="font-size:'16px"
                      >
                        Donut Chart: Customer Segment Response Rates
                      </p>
                    </b-card-body>
                  </b-card>
                </b-col>
                <b-col cols="6" md="3">
                  <b-card border-variant="secondary" class="h-100">
                    <b-card-body>
                      <h5
                        class="text-body font-weight-bold text-nowrap text-center"
                      >
                        Geographic Performance
                      </h5>
                      <p
                        class="text-center mt-2 text-muted mb-0"
                        style="font-size:'16px"
                      >
                        Heat Map: Geographic Performance
                      </p>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <!-- Upcoming Fixtures -->
            <b-card>
              <b-row class="d-flex align-items-center">
                <b-col cols="8">
                  <h4 class="font-weight-bold mb-0">Active Communications</h4>
                </b-col>
                <b-col cols="4" class="text-right">
                  <b-button-group>
                    <b-button size="sm" variant="outline-secondary"
                      >All</b-button
                    >
                    <b-button size="sm" variant="outline-secondary"
                      >Banner</b-button
                    >
                    <b-button size="sm" variant="outline-secondary"
                      >SMS</b-button
                    >
                    <b-button size="sm" variant="outline-secondary"
                      >Push</b-button
                    >
                    <b-button size="sm" variant="outline-secondary"
                      >In-App</b-button
                    >
                  </b-button-group>
                </b-col>
              </b-row>
              <b-table
                class="mt-2"
                :items="fixtures"
                :fields="fixtureFields"
                responsive
                thead-class="text-nowrap"
              >
                <template #cell(campaignName)="{ item }">
                  <b-media vertical-align="center">
                    <div class="d-flex align-items-center text-nowrap">
                      {{ item.campaignName }}
                    </div>
                  </b-media>
                </template>
                <template #cell(type)="{ item }">
                  <b-media vertical-align="center">
                    <div class="d-flex align-items-center text-nowrap">
                      {{ item.type }}
                    </div>
                  </b-media>
                </template>
                <template #cell(targetAudience)="{ item }">
                  <b-media vertical-align="center">
                    <div class="d-flex align-items-center text-nowrap">
                      {{ item.targetAudience }}
                    </div>
                  </b-media>
                </template>
                <template #cell(impressions)="{ item }">
                  <b-media vertical-align="center">
                    <div class="d-flex align-items-center text-nowrap">
                      {{ item.impressions }}
                    </div>
                  </b-media>
                </template>
                <template #cell(engagement)="{ item }">
                  <b-media vertical-align="center">
                    <div class="d-flex align-items-center text-nowrap">
                      {{ item.engagement }}
                    </div>
                  </b-media>
                </template>
                <template #cell(status)="{ item }">
                  <b-media vertical-align="center">
                    <div
                      class="text-white bg-success d-flex rounded justify-content-center align-items-center font-weight-bold"
                      style="padding: 2px 4px; width: fit-content"
                    >
                      {{ item.status }}
                    </div>
                  </b-media>
                </template>
                <template #cell(actions)>
                  <b-media vertical-align="center">
                    <div class="d-flex align-items-center">
                      <feather-icon
                        size="20"
                        icon="EditIcon"
                        class="pointer text-primary mr-1"
                      />
                      <feather-icon
                        size="20"
                        icon="CopyIcon"
                        class="pointer text-primary mr-1"
                      />
                      <feather-icon
                        size="20"
                        icon="PauseIcon"
                        class="pointer text-primary"
                      />
                    </div>
                  </b-media>
                </template>
              </b-table>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-card>
              <b-row>
                <b-col cols="6" md="3">
                  <b-card border-variant="secondary">
                    <b-card-body>
                      <h5
                        class="text-body font-weight-bold text-nowrap text-center"
                      >
                        <feather-icon icon="Volume1Icon" size="20" />
                        Create New Banner Campaign
                      </h5>
                      <p
                        class="text-center text-muted mb-0"
                        style="font-size:'16px"
                      >
                        Design and launch targeted banner ads across platform
                      </p>
                      <div class="text-center mt-1">
                        <b-button variant="outline-primary" class="">
                          <span class="text-primary">Get Started</span>
                          <feather-icon
                            icon="ArrowRightIcon"
                            class="text-primary"
                          />
                        </b-button>
                      </div>
                    </b-card-body>
                  </b-card>
                </b-col>
                <b-col cols="6" md="3">
                  <b-card border-variant="secondary">
                    <b-card-body>
                      <h5
                        class="text-body font-weight-bold text-nowrap text-center"
                      >
                        <feather-icon icon="MessageCircleIcon" size="20" />
                        Send SMS Blast
                      </h5>
                      <p
                        class="text-center text-muted mb-0"
                        style="font-size:'16px"
                      >
                        Create and send bulk SMS to targeted customer segments
                      </p>
                      <div class="text-center mt-1">
                        <b-button variant="outline-primary" class="">
                          <span class="text-primary">Get Started</span>
                          <feather-icon
                            icon="ArrowRightIcon"
                            class="text-primary"
                          />
                        </b-button>
                      </div>
                    </b-card-body>
                  </b-card>
                </b-col>
                <b-col cols="6" md="3">
                  <b-card border-variant="secondary">
                    <b-card-body>
                      <h5
                        class="text-body font-weight-bold text-nowrap text-center"
                      >
                        <feather-icon icon="BellIcon" size="20" />
                        Schedule Push Notification
                      </h5>
                      <p
                        class="text-center text-muted mb-0"
                        style="font-size:'16px"
                      >
                        Create and schedule mobile app push notifications
                      </p>
                      <div class="text-center mt-1">
                        <b-button variant="outline-primary" class="">
                          <span class="text-primary">Get Started</span>
                          <feather-icon
                            icon="ArrowRightIcon"
                            class="text-primary"
                          />
                        </b-button>
                      </div>
                    </b-card-body>
                  </b-card>
                </b-col>
                <b-col cols="6" md="3">
                  <b-card border-variant="secondary">
                    <b-card-body>
                      <h5
                        class="text-body font-weight-bold text-nowrap text-center"
                      >
                        <feather-icon icon="SmartphoneIcon" size="20" />
                        Launch In-App Survey
                      </h5>
                      <p
                        class="text-center text-muted mb-0"
                        style="font-size:'16px"
                      >
                        Create and deploy in-app surveys and feedback forms
                      </p>
                      <div class="text-center mt-1">
                        <b-button variant="outline-primary" class="">
                          <span class="text-primary">Get Started</span>
                          <feather-icon
                            icon="ArrowRightIcon"
                            class="text-primary"
                          />
                        </b-button>
                      </div>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Spinner from "@core/components/Spinner";
import {
  BBadge,
  BButton,
  BCard,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormInput,
  BLink,
  BMedia,
  BPagination,
  BRow,
  VBModal,
  BButtonGroup,
  BTable,
  BCardBody,
  BNav,
  BNavItem,
  BNavbarToggle,
  BCollapse,
  BNavbar,
  BNavbarNav,
} from "bootstrap-vue";
import vSelect from "vue-select";
export default {
  components: {
    Performance,
    BButton,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BMedia,
    BLink,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    Spinner,
    BBadge,
    BButtonGroup,
    BTable,
    BCardBody,
    BNav,
    BNavItem,
    BCollapse,
    BNavbarToggle,
    BNavbar,
    BNavbarNav,
  },
  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {
      option: "Last 30 days",
      options: [
        { label: "Last 30 days", value: "last30days" },
        { label: "Last 7 days", value: "last7days" },
        { label: "Last 90 days", value: "last90days" },
      ],
      fixtures: [
        {
          campaignName: "Summer Racing Carnival",
          type: "Banner",
          targetAudience: "Racing Enthusiasts",
          impressions: "45,892",
          engagement: "3.2%",
          status: "Active",
        },
        {
          campaignName: "Weekend Special Offer",
          type: "SMS",
          targetAudience: "VIP Members",
          impressions: "12,450",
          engagement: "8.7%",
          status: "Active",
        },
        {
          campaignName: "Game Start Notification",
          type: "Push",
          targetAudience: "All App Users",
          impressions: "78,321",
          engagement: "12.4%",
          status: "Active",
        },
        {
          campaignName: "Customer Satisfaction Survey",
          type: "In-App",
          targetAudience: "New App Users",
          impressions: "8,845",
          engagement: "4.1%",
          status: "Active",
        },
        {
          campaignName: "New Mobile App Promotion",
          type: "Banner",
          targetAudience: "All Users",
          impressions: "125,789",
          engagement: "5.8%",
          status: "Active",
        },
      ],
      fixtureFields: [
        { key: "campaignName", label: "CAMPAIGN NAME" },
        { key: "type", label: "TYPE" },
        { key: "targetAudience", label: "TARGET AUDIENCE" },
        { key: "impressions", label: "IMPRESSIONS" },
        { key: "engagement", label: "ENGAGEMENT" },
        { key: "status", label: "STATUS" },
        { key: "actions", label: "ACTIONS" },
      ],
    };
  },
  computed: {
  },
  async mounted() {},
  methods: {},
  setup() {},
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.id-column {
  max-width: 300px;
  min-width: 120px;
  word-break: break-word;
}
.text-title {
  color: black;
  font-weight: 500;
}
.pointer {
  cursor: pointer;
}
</style>